module.exports = __webpack_public_path__ + "assets/img/assistant-zgyd.9a7f24a1.png";